// src/v2/components/modules/DTRWithOT/components/DTRWithOTTable.js
import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import { StatusBadge } from "../../../../../common/Badge";
import { FEATURES } from "../../../../../config/features";

const DTRWithOTTable = ({ data, onEdit, onApprove }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const headers = [
    "Employee Id",
    "Employee",
    "Date",
    "Time In",
    "Time Out",
    "OT Hours",
    ...(FEATURES.ALLOW_OT_EDIT_APPROVE ? ["Is Manually Updated?"] : []),
    ...(FEATURES.ALLOW_OT_EDIT_APPROVE ? ["Status"] : []),
    ...(FEATURES.ALLOW_OT_EDIT_APPROVE ? ["Action"] : []),
  ];

  const accessors = [
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "date",
    "timeIn",
    "timeOut",
    "otHours",
    ...(FEATURES.ALLOW_OT_EDIT_APPROVE ? ["isManualOverride"] : []),
    ...(FEATURES.ALLOW_OT_EDIT_APPROVE ? ["status"] : []),
    ...(FEATURES.ALLOW_OT_EDIT_APPROVE ? ["actions"] : []),
  ];

  const actions = [
    {
      name: "Edit",
      tooltip: "Edit Details",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: (item) => onEdit(item),
      visible: (item) => !item.isApproved, 
    },
    {
      name: "Approve",
      tooltip: "Approve OT",
      icon: <ThumbUpIcon fontSize="small" />,
      className: "bg-blue-500 hover:bg-blue-600 flex items-center", // Amber suggests "Warning/Action required"
      function: (item) => onApprove(item),
      visible: (item) => !item.isApproved, 
    }
  ];


  // Logic adapted from legacy SetInfo
  const formatTime = (timeString) => {
    if (!timeString) return "-";
    const date = new Date(timeString);
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  };

  const formatOT = (value) => {
    if (typeof value !== 'number') return value || "0.00";
    return value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const customCellRenderer = (row, accessor) => {
    if (accessor === "date") {
      return <span>{formatDate(row[accessor])}</span>;
    }
    if (accessor === "timeIn" || accessor === "timeOut") {
      return <span>{formatTime(row[accessor])}</span>;
    }
    if (accessor === "otHours") {
      return <span className="font-semibold text-blue-700">{formatOT(row[accessor])}</span>;
    }
    if (accessor === "isManualOverride") {
      return <StatusBadge status={row[accessor]} />;
    }
    if (accessor === "status") {
      return <StatusBadge status={row[accessor]} />;
    }
    return null;
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
      <CreateTable
        tableName="DTRWithOTTable"
        headers={headers}
        accessors={accessors}
        data={data}
        actions={actions}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={10}
        totalItems={data.length}
        customCellRenderer={customCellRenderer}
        emptyMessage="No records found for the selected filters."
      />
    </div>
  );
};

export default DTRWithOTTable;